import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import {
    Link, useLocation, useNavigate, useParams
} from "react-router-dom";
import Breadcrumb from '../../Components/Breadcrumb';
import TransportForm from './form'; 
import TransportService from './service';


const TransportEdit: FC = () => {  
    const location: any = useLocation();
    const navigate = useNavigate();

    const transportService = new TransportService();

    const { t } = useTranslation();

    let { id } = useParams();

    const [transport, setTransport] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        transportService.getTransport(Number(id)).then(async function (response: any) {
            console.log(response); 
            setTransport(response.data.details);
            setLoading(false); 
        })
          .catch(function (error: any) {
            console.log(error);
            setLoading(false); 
        });
    }, []);

    return ( 
        <> 
            <Breadcrumb />

            <div className="container-fluid">

                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title">
                                    { t('Modifier un service de transport') }
                                </h4>
                                <Link type="button" to="/transport/list"
                                    className="btn waves-effect waves-light btn-primary">
                                    { t('Liste des services de transport') }   
                                </Link>
                                <br />
                                <br />

                                { !loading && transport ?
                                    <TransportForm state='edit' transport={ transport } />  
                                    :
                                    <div className="spinner-border text-primary spinner-border-lg" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                }     
                                 
                                </div>
                            </div> 
                    </div> 
                </div>

            </div>   
        </>                   
    );
}

export default TransportEdit